<template>
    <main id="Central__Calendar" class="page-layout">
        <div class="mt-2 rounded task-manager-header">Patient Task Manager</div>

        <main class="card px-0 h-100" id="App__Calendar">
            <ListLayout
                :has-title="hideTitle"
                :page-title="patientName"
                form-title="Bulk Reassign"
                :show-form="isAddItemRequested"
            >
                <template v-slot:list-form>
                    <!-- FORM CONTENT -->
                    <PatientBulkReassign
                        :application="application"
                        :agency-id="agencyId"
                        :patient-id="patientId"
                        :selected-task-id="selectedTaskId"
                        :selected-user-id="selectedUserId"
                        :date-from="dateFrom"
                        :date-to="dateTo"
                        :branch-id="branchId"
                        :page-reset="pageReset"
                        :close-reassign-form="closeReassignForm"
                    />
                </template>
                <!-- HEADER CONTENT -->
                <template v-slot:list-header>
                    <div class="d-flex flex-wrap flex-xl-nowrap w-100">
                        <div class="d-flex flex-wrap flex-xl-nowrap align-items-center p-0 m-0 w-100">
                            <div class="form-group me-2 mb-2 flex-shrink-1">
                                <div>
                                    <label for="date-to">Date From:</label>
                                    <DatePicker :getDate="changeDate">
                                        <div class="input-group date datepickerInput">
                                            <input
                                                type="text"
                                                class="form-control"
                                                placeholder="MM/DD/YYYY"
                                                autocomplete="off"
                                                name="dateFrom"
                                                :value="formatDateInput(dateFrom)"
                                            />
                                            <div class="input-group-addon input-group-append">
                                                <div class="input-group-text">
                                                    <i class="fa fa-calendar"></i>
                                                </div>
                                            </div>
                                        </div>
                                    </DatePicker>
                                </div>
                            </div>
                            <div class="form-group me-2 mb-2 flex-shrink-1">
                                <div>
                                    <label for="date-to">Date To:</label>
                                    <DatePicker :getDate="changeDate">
                                        <div class="input-group date datepickerInput">
                                            <input
                                                name="dateTo"
                                                type="text"
                                                class="form-control"
                                                placeholder="MM/DD/YYYY"
                                                :value="formatDateInput(dateTo)"
                                            />
                                            <div class="input-group-addon input-group-append">
                                                <div class="input-group-text">
                                                    <i class="fa fa-calendar"></i>
                                                </div>
                                            </div>
                                        </div>
                                    </DatePicker>
                                </div>
                            </div>
                            <div class="form-group mb-2">
                                <div>
                                    <label for="date-to">Filter by text:</label>
                                    <div class="input-group">
                                        <input
                                            type="text"
                                            class="form-control border-end-0"
                                            placeholder="Start Typing"
                                            v-model="term"
                                        />
                                        <span class="input-group-append">
                                            <div class="input-group-text bg-transparent p-2">
                                                <i class="fas fa-search font-size-sm"></i>
                                            </div>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            class="col-auto d-flex flex-wrap-reverse flex-xl-nowrap row-gap-2 ms-auto me-0 p-0 mt-auto mb-auto btns-container"
                        >
                            <div class="d-flex ms-auto">
                                <button type="button" class="btn btn-sm btn-primary ms-2" @click="taskRefresh()">
                                    Refresh
                                </button>
                                <button
                                    type="button"
                                    :disabled="selectedTaskId.length === 0"
                                    class="btn btn-sm btn-primary ms-2"
                                    @click="deleteTask()"
                                >
                                    Delete
                                </button>
                            </div>
                            <div class="d-flex ms-auto ms-md-0">
                                <button
                                    type="button"
                                    :disabled="selectedTaskId.length === 0"
                                    class="btn btn-sm btn-primary ms-2"
                                    @click="openReassignForm()"
                                >
                                    Reassign
                                </button>
                                <button
                                    type="button"
                                    class="btn btn-sm btn-outline-primary ms-2"
                                    @click="redirectToEmployeeList()"
                                >
                                    View Calendar
                                </button>
                            </div>
                        </div>
                    </div>
                </template>
                <div class="table-scroll-wrapper">
                    <table class="table table-responsive-md border border-gray">
                        <thead v-if="!getHasData">
                            <tr class="bg-table-header">
                                <th>
                                    <div class="form-check custom-checkbox form-check-inline ms-1 me-0">
                                        <input
                                            type="checkbox"
                                            class="form-check-input"
                                            id="task-select-all"
                                            v-model="selectAll"
                                            @change="changeAllSelection()"
                                        />
                                        <label class="form-check-label highlight" for="task-select-all">
                                            <span></span>
                                        </label>
                                    </div>
                                </th>
                                <th>Task Document</th>
                                <th>Date</th>
                                <th>Time</th>
                                <th>Status</th>
                                <th>Employee</th>
                            </tr>
                        </thead>
                        <thead v-else>
                            <tr class="bg-table-header">
                                <th>
                                    <div class="form-check custom-checkbox form-check-inline ms-1 me-0">
                                        <input
                                            type="checkbox"
                                            class="form-check-input"
                                            id="task-select-all"
                                            v-model="selectAll"
                                            @change="changeAllSelection()"
                                        />
                                        <label class="form-check-label highlight" for="task-select-all">
                                            <span></span>
                                        </label>
                                    </div>
                                </th>
                                <th>
                                    <SortableTh
                                        :sort-by="sortBy"
                                        v-on:sortByUpdated="sortByUpdated"
                                        :sort-order="sortOrder"
                                        v-on:sortOrderUpdated="sortOrderUpdated"
                                        sort-string="TaskName"
                                        >Task Document
                                    </SortableTh>
                                </th>
                                <th>
                                    <SortableTh
                                        :sort-by="sortBy"
                                        v-on:sortByUpdated="sortByUpdated"
                                        :sort-order="sortOrder"
                                        v-on:sortOrderUpdated="sortOrderUpdated"
                                        sort-string="StartDate"
                                    >
                                        Date
                                    </SortableTh>
                                </th>
                                <th>
                                    <SortableTh
                                        :sort-by="sortBy"
                                        v-on:sortByUpdated="sortByUpdated"
                                        :sort-order="sortOrder"
                                        v-on:sortOrderUpdated="sortOrderUpdated"
                                        sort-string="StartTime"
                                    >
                                        Time
                                    </SortableTh>
                                </th>
                                <th>
                                    <SortableTh
                                        :sort-by="sortBy"
                                        v-on:sortByUpdated="sortByUpdated"
                                        :sort-order="sortOrder"
                                        v-on:sortOrderUpdated="sortOrderUpdated"
                                        sort-string="Status"
                                    >
                                        Status
                                    </SortableTh>
                                </th>
                                <th>
                                    <SortableTh
                                        :sort-by="sortBy"
                                        v-on:sortByUpdated="sortByUpdated"
                                        :sort-order="sortOrder"
                                        v-on:sortOrderUpdated="sortOrderUpdated"
                                        sort-string="UserFirstName"
                                    >
                                        Employee
                                    </SortableTh>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <!-- EMPTY -->
                            <tr class="table-empty" v-if="!isLoading && !isError && !getHasData">
                                <td :colspan="columns">
                                    <h3>No Tasks Found.</h3>
                                </td>
                            </tr>
                            <!-- ERROR -->
                            <tr class="table-error" v-if="!isLoading && isError">
                                <td :colspan="columns">
                                    <ErrorMessageHandler title="Task list" v-on:try-again="taskRefresh()" />
                                </td>
                            </tr>
                            <!-- LOADING -->
                            <tr v-for="i of getLoadingCount" :key="i" class="table-loading" v-if="isLoading">
                                <td v-for="j of columns" :key="j">
                                    <span class="shimmer-loading"></span>
                                </td>
                            </tr>
                        </tbody>
                        <!-- LIST -->
                        <template> </template>
                        <template v-if="!isLoading && !isError && getHasData">
                            <tbody>
                                <tr
                                    :class="`${selectedTaskId.includes(task.Id) ? 'select-row' : ''}`"
                                    v-for="task of filteredTasks"
                                    :key="task.Id"
                                >
                                    <td>
                                        <div
                                            class="form-check custom-checkbox form-check-inline ms-1 zindex-0"
                                            v-if="!isReadOnlyTask(task)"
                                        >
                                            <input
                                                type="checkbox"
                                                class="form-check-input"
                                                :id="`task_${task.Id}`"
                                                :value="task"
                                                v-model="selectedTaskId"
                                                @click="taskChanged($event)"
                                            />
                                            <label class="form-check-label" :for="`task_${task.Id}`">
                                                <span></span>
                                            </label>
                                        </div>
                                    </td>
                                    <td>{{ task.TaskName }}</td>
                                    <td>{{ formatDate(task.StartDate, "MM/DD/YY") }}</td>
                                    <td>{{ getVisitTime(task) }}</td>
                                    <td>
                                        <EmptyTextHandler :text="task.Status" />
                                    </td>
                                    <td>{{ getFullName(task) }}</td>
                                </tr>
                            </tbody>
                        </template>
                    </table>
                </div>
            </ListLayout>
        </main>
    </main>
</template>

<script lang="ts" src="./TaskManager.ts"></script>
<style src="./TaskManager.scss"></style>
